export default __webpack_public_path__ + "static/2011-5ec856b9a008a33c11cdd24400dabc42.svg";